 function getDefaultValues(){
 let defaultValues = {
    // Page Info
    productName: "RentEase",
    productLogo: "",
    duePeriod: 30,

    // Global Theme
    appBg: "#f4f5f8",
    appText: "#1a1a1a",
    btnBg: "#7F77DD",
    btnText: "#ffffff",

    // Header & Search Theme
    headerBgStart: "#3C3489",
    headerBgEnd: "#7F77DD",
    headerText: "#ffffff",
    searchBg: "#ffffff",
    searchText: "#1a1a1a",

    // Category Types Theme
    chipBg: "#ffffff",
    chipText: "#4a4a55",
    chipHoverBg: "#EEEDFE",
    chipHoverText: "#3C3489",
    chipActiveBg: "#7F77DD",
    chipActiveText: "#ffffff",

    // Product Card Theme
    cardBg: "#ffffff",
    cardText: "#1a1a1a",
    cardBorder: "rgba(0,0,0,0.08)",
    cardHoverBorder: "rgba(127,119,221,0.5)",

    // Modal & Checkout Theme
    modalBg: "#ffffff",
    modalText: "#1a1a1a",

    // Content Settings
    productTitle: "Rent anything,<br>delivered to you",
    productTagline: "Explore top-quality products at daily rates.",
    searchPlaceholder: "Search for equipment, tools, furniture...",

    // Checkout Settings
    confirmMessage: "We'll confirm your rental within 2 hours.",
    namePlaceholder: "e.g. Ravi Kumar",
    emailPlaceholder: "you@example.com",
    phonePlaceholder: "+91 98765 43210",
    addressPlaceholder: "Delivery address",

    // Regional & Catalog
    currency: "₹",
    categories: ["Furniture", "Electronics", "Vehicles", "Tools", "Appliances"],

    // Default Catalog: 50 Products (10 per category)
    products: [
  /* --- FURNITURE --- */
  { id: 1, name: "Ergonomic Office Chair", description: "Lumbar support, adjustable height and armrests.", image: "https://images.unsplash.com/photo-1505843490538-5133c6c7d0e1?auto=format&fit=crop&w=400&q=80", category: "Furniture", dailyRate: 350, maxLimit: 20 },
  { id: 2, name: "3-Seater Sofa", description: "Plush fabric sofa, perfect for events or temporary living.", image: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?auto=format&fit=crop&w=400&q=80", category: "Furniture", dailyRate: 800, maxLimit: 5 },
  { id: 3, name: "Wooden Dining Table", description: "Seats 6 people comfortably. Solid oak.", image: "https://images.unsplash.com/photo-1604578762246-41134e37f9cc?auto=format&fit=crop&w=400&q=80", category: "Furniture", dailyRate: 600, maxLimit: 10 },
  { id: 4, name: "Queen Size Bed Frame", description: "Sturdy metal and wood frame. Mattress not included.", image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=400&q=80", category: "Furniture", dailyRate: 500, maxLimit: 8 },

  /* --- ELECTRONICS --- */
  { id: 11, name: "DSLR Camera Kit", description: "24MP camera with 18-55mm lens and tripod.", image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&w=400&q=80", category: "Electronics", dailyRate: 800, maxLimit: 5 },
  { id: 12, name: "MacBook Pro 16\"", description: "M1 Pro chip, 16GB RAM, ideal for video editing.", image: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=400&q=80", category: "Electronics", dailyRate: 1500, maxLimit: 3 },
  { id: 13, name: "4K Smart Projector", description: "3000 lumens, built-in WiFi and HDMI ready.", image: "https://images.unsplash.com/photo-1589115715975-5231c5b8b94f?auto=format&fit=crop&w=400&q=80", category: "Electronics", dailyRate: 1200, maxLimit: 4 },
  { id: 14, name: "iPad Pro 12.9\"", description: "Tablet with Apple Pencil, perfect for digital art.", image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?auto=format&fit=crop&w=400&q=80", category: "Electronics", dailyRate: 900, maxLimit: 5 },

  /* --- VEHICLES --- */
  { id: 21, name: "Electric Kick Scooter", description: "30km range, max speed 25km/h. Helmet included.", image: "https://images.unsplash.com/photo-1593026367807-5e6080344d93?auto=format&fit=crop&w=400&q=80", category: "Vehicles", dailyRate: 500, maxLimit: 8 },
  { id: 22, name: "Mountain Bicycle", description: "21-speed gears, front suspension, disc brakes.", image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?auto=format&fit=crop&w=400&q=80", category: "Vehicles", dailyRate: 300, maxLimit: 10 },
  { id: 23, name: "City Commuter Bike", description: "Lightweight frame, rear rack, perfect for urban riding.", image: "https://images.unsplash.com/photo-1507035895480-2b3156c31fc8?auto=format&fit=crop&w=400&q=80", category: "Vehicles", dailyRate: 250, maxLimit: 15 },
  { id: 24, name: "Economy Sedan", description: "5-seater, automatic transmission, unlimited mileage.", image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&w=400&q=80", category: "Vehicles", dailyRate: 2500, maxLimit: 2 },

  /* --- TOOLS --- */
  { id: 31, name: "Cordless Power Drill", description: "18V Lithium-ion drill with 50-piece bit set.", image: "https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=400&q=80", category: "Tools", dailyRate: 250, maxLimit: 10 },
  { id: 32, name: "Circular Saw 7-1/4\"", description: "15-Amp corded circular saw with laser guide.", image: "https://images.unsplash.com/photo-1572981779307-38b8cabb2407?auto=format&fit=crop&w=400&q=80", category: "Tools", dailyRate: 300, maxLimit: 5 },
  { id: 33, name: "Portable Air Compressor", description: "6-gallon pancake compressor, 150 PSI max.", image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=400&q=80", category: "Tools", dailyRate: 400, maxLimit: 4 },
  { id: 34, name: "2000W Inverter Generator", description: "Super quiet portable power for events or backup.", image: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&w=400&q=80", category: "Tools", dailyRate: 800, maxLimit: 3 },

  /* --- APPLIANCES --- */
  { id: 41, name: "7kg Washing Machine", description: "Front-load washing machine with quick cycle.", image: "https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?auto=format&fit=crop&w=400&q=80", category: "Appliances", dailyRate: 600, maxLimit: 5 },
  { id: 42, name: "80L Mini Refrigerator", description: "Compact fridge, energy efficient, includes freezer box.", image: "https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?auto=format&fit=crop&w=400&q=80", category: "Appliances", dailyRate: 400, maxLimit: 10 },
  { id: 43, name: "20L Microwave Oven", description: "Digital controls, 800W power output.", image: "https://images.unsplash.com/photo-1585659722983-38ca819efa42?auto=format&fit=crop&w=400&q=80", category: "Appliances", dailyRate: 250, maxLimit: 10 },
  { id: 44, name: "Portable Air Conditioner", description: "10,000 BTU, cools up to 300 sq ft. Window kit included.", image: "https://images.unsplash.com/photo-1522049187317-18ce632314ec?auto=format&fit=crop&w=400&q=80", category: "Appliances", dailyRate: 700, maxLimit: 6 },
]
  };
  return defaultValues
}
function appendDefaultValues(values){
  const defaultValues = getDefaultValues()
  let newValues = {...values}
  for (var key of Object.keys(values)){
    if (!newValues[key] && defaultValues[key]){
       newValues[key] = defaultValues[key]
    }
  }
  return newValues

}

/**
 * Preprocesses raw user input data for the Product Page Handlebars template.
 * Injects default values for any missing, undefined, or empty fields.
 * * @param {Object} rawData - The raw data from the database/form.
 * @returns {Object} A sanitized data object ready for Handlebars injection.
 */
function preprocessProductpageData(rawData) {
  const defaultValues = getDefaultValues()
  // Ensure we are working with an object even if null is passed
  const data = rawData || {};

  // Define the strict defaults based on your Granular JSON schema


  const processedData = {};

  // Loop through all keys in the default values
  for (const key in defaultValues) {
    if (Object.prototype.hasOwnProperty.call(defaultValues, key)) {

      // Check if the raw data has this key AND it's not null/undefined/empty string
      if (data[key] !== undefined && data[key] !== null && data[key] !== "") {

        // Special handling for Arrays (like categories or products)
        if (Array.isArray(defaultValues[key])) {
          processedData[key] = Array.isArray(data[key]) && data[key].length > 0
            ? data[key]
            : defaultValues[key];
        }
        // Special handling for numbers (like duePeriod)
        else if (typeof defaultValues[key] === 'number') {
          const parsedNum = Number(data[key]);
          processedData[key] = !isNaN(parsedNum) ? parsedNum : defaultValues[key];
        }
        // Standard strings
        else {
          processedData[key] = data[key];
        }

      } else {
        // Fallback to default if missing or invalid
        processedData[key] = defaultValues[key];
      }
    }
  }

  // Preserve any extra data that might be in rawData but not in defaults (optional)
  for (const key in data) {
    if (!processedData.hasOwnProperty(key)) {
      processedData[key] = data[key];
    }
  }

  return {appData: JSON.stringify(processedData),mobileview:rawData.mobileview};
}


export { appendDefaultValues,preprocessProductpageData };
